'use client';

import React from 'react';
import Link from 'next/link';

import * as Styled from './styled';
import pluralize from 'pluralize';

import { IRepository, ICommit } from '@/types';
import { toTimeAgo } from '@/lib/dateTime';
import * as Icon from '@/ui/Icon';

const CommitHistory: React.FC<{
  commit: ICommit;
  repository: IRepository;
  fullResourcePath: string;
  commitCount?: number | undefined;
}> = ({ commit, repository, fullResourcePath, commitCount }) => {
  const commitsPath = `/${repository.namespace}/${repository.name}/commits/${fullResourcePath}`;
  const commitPath = `/${repository.namespace}/${repository.name}/commit/${commit.id}`;
  const commitsText = `${commitCount ? pluralize('Commit', commitCount, true) : 'No Commits'} `;
  return (
    <Styled.CommitHistory>
      <Styled.TightRow className="lastCommit">
        <Link href={commitPath} className="hover-link">
          <div className="commitRef">{commit.id}</div>
        </Link>
        <div>·</div>
        <div>{toTimeAgo(commit.timestamp)}</div>
      </Styled.TightRow>
      <Styled.TightRow>
        <Link href={commitsPath} className="hover-link">
          <Icon.History height={14} />
        </Link>
        <Link href={commitsPath} className="hover-link">
          <span style={{ whiteSpace: 'nowrap' }}>{commitsText}</span>
        </Link>
      </Styled.TightRow>
    </Styled.CommitHistory>
  );
};

export default CommitHistory;
